"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortSelector = exports.catalogCarSelector = exports.paymentSelector = exports.popularCarsSelector = exports.modalSelector = exports.mediaQuerySelector = exports.lastArrivalsSelector = exports.inStockListSelector = exports.filtersSelector = exports.favoritesSelector = exports.editCarSelector = exports.contactsSelector = exports.carsSelector = exports.banksListSelector = exports.adminSelector = exports.aboutSelector = void 0;
var aboutSelector = function (state) { return state.about; };
exports.aboutSelector = aboutSelector;
var adminSelector = function (state) { return state.admin; };
exports.adminSelector = adminSelector;
var banksListSelector = function (state) { return state.banksList; };
exports.banksListSelector = banksListSelector;
var carsSelector = function (state) { return state.cars; };
exports.carsSelector = carsSelector;
var contactsSelector = function (state) { return state.contacts; };
exports.contactsSelector = contactsSelector;
var editCarSelector = function (state) { return state.editCar; };
exports.editCarSelector = editCarSelector;
var favoritesSelector = function (state) { return state.favorites; };
exports.favoritesSelector = favoritesSelector;
var filtersSelector = function (state) { return state.filter; };
exports.filtersSelector = filtersSelector;
var inStockListSelector = function (state) { return state.inStockList; };
exports.inStockListSelector = inStockListSelector;
var lastArrivalsSelector = function (state) { return state.lastArrivalsList; };
exports.lastArrivalsSelector = lastArrivalsSelector;
var mediaQuerySelector = function (state) { return state.mediaQuery; };
exports.mediaQuerySelector = mediaQuerySelector;
var modalSelector = function (state) { return state.modal.modals; };
exports.modalSelector = modalSelector;
var popularCarsSelector = function (state) { return state.popularCarsList; };
exports.popularCarsSelector = popularCarsSelector;
var paymentSelector = function (state) { return state.payment; };
exports.paymentSelector = paymentSelector;
var catalogCarSelector = function (state) { return state.catalogCar; };
exports.catalogCarSelector = catalogCarSelector;
var sortSelector = function (state) { return state.sortCars; };
exports.sortSelector = sortSelector;
